(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("imjoyCore", [], factory);
	else if(typeof exports === 'object')
		exports["imjoyCore"] = factory();
	else
		root["imjoyCore"] = factory();
})(window, function() {
return 